<template>
    <v-container>
      <div
          style="background-color: white; display: flex;"
          class="ma-0 pt-12 padding-cv"
      >
        <CurriculumComponent ref="curriculum" />

        <!-- <ChatComponent /> -->
        <div>
          <vue-html2pdf
              ref="html2pdf"
              :show-layout="false"
              :float-layout="true"
              :enable-download="true"
              :preview-modal="false"
              :paginate-elements-by-height="1200"
              filename="curriculum"
              :pdf-quality="1"
              :manual-pagination="true"
              pdf-format="letter"
              pdf-orientation="portrait"
              pdf-content-width="8.5in"
          >
            <section slot="pdf-content">
              <curriculum-document/>
            </section>
          </vue-html2pdf>
        </div>
      </div>

      <v-row class="d-flex justify-center mt-12 mb-3">
        <v-btn
            rounded
            dark
            color="#22234a"
            class="my-text-button"
            x-large
            @click="downloadPdf()"
        >Descargar CV
          <v-icon class="ml-2" color="white">mdi-tray-arrow-down</v-icon>
        </v-btn>
      </v-row>
    </v-container>
</template>

<script>
import CurriculumComponent from "../../components/CurriculumComponent.vue";
// import CurriculumComponentPDF from '../../components/CurriculumComponentPDF.vue';

import curriculumDocument from "./curriculumDocument.vue";

import AppFooter from "../../components/AppFooter.vue";
import ChatComponent from "../../components/ChatComponent.vue";
import {mapState} from "vuex";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  components: {
    CurriculumComponent,
    // CurriculumComponentPDF,
    curriculumDocument,
    AppFooter,
    ChatComponent
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(["token"])
  },
  methods: {
    async downloadPdf() {
      try {
        const response = await this.services.datosPersona.descargarCV(
          this.$refs.curriculum?.userInfo.id_persona
        );
        const nombreNuevo =this.$refs.curriculum?.userInfo?.nombres.replace(/ /g, "_");
        const base64 = response?.data?.data?.pdf
        const filename = `cv_${nombreNuevo}.pdf`
       
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Crear Blob
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Crear URL para descarga
        const url = window.URL.createObjectURL(blob);

        // Crear enlace y descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();

        // Liberar memoria
        window.URL.revokeObjectURL(url);
      // const pdfContent = this.$refs.html2pdf?.$refs?.pdfContent;
      // const target = pdfContent?.firstChild || pdfContent;

      // if (!target) return;

      // // Render a high-res canvas of the CV
      // const canvas = await html2canvas(target, {
      //   scale: 2,
      //   useCORS: true,
      //   backgroundColor: "#ffffff"
      // });

      // const imgData = canvas.toDataURL("image/jpeg", 0.98);
      // const pdf = new jsPDF("p", "in", "letter");
      // const pageWidth = pdf.internal.pageSize.getWidth();
      // const pageHeight = pdf.internal.pageSize.getHeight();

      // let imgWidth = pageWidth;
      // let imgHeight = (canvas.height * imgWidth) / canvas.width;

      // // Fit to page height if needed
      // if (imgHeight > pageHeight) {
      //   imgHeight = pageHeight;
      //   imgWidth = (canvas.width * imgHeight) / canvas.height;
      // }

      // const x = (pageWidth - imgWidth) / 2;
      // const y = 0;

      // pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);
      // pdf.save("curriculum.pdf");
      } catch (error) {
        
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cv-pdf {
  position: relative;
  height: 100% !important;

  ::v-deep .pdfCard--style {
    height: 1300px !important;
    max-height: 1300px !important;
  }

  ::v-deep .text-size--pdf {
    font-size: 20px !important;
  }

  ::v-deep .items--style {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }
}

.card {
  background-color: #f5f5f5;
  border-radius: 25px;
}

.bg-primary-color {
  color: #22234a;
}

.my-button:hover {
  background-color: #333458;
  color: white;
}

.pdf-item {
  display: flex;
  position: relative;
  height: 1340px !important;
  max-height: 1340px !important;
  padding: 20px;
}

@media (max-width: 960px) {
  .padding-cv {
    padding-left: 5vw !important;
    padding-right: 5vw !important;
  }
}
</style>
